// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3A1CJ","col":"styles_col__1jImh"};